import { Alert, Button, CircularProgress, IconButton, InputAdornment, TextField } from '@mui/material';
import React, { useState, useRef } from 'react';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import "../css/login.css"

const Login = ({ setLogin, setToken }) => {
    const unameref = useRef(null);
    const pwdref = useRef(null);
    const [pwdSee, setpwdSee] = useState(true);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const keyDownCustUname = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            pwdref.current.focus();
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        checkLogin(unameref.current.value, pwdref.current.value);
    }

    const checkLogin = (username, password) => {
        if (!username || !password) {
            setError("Нэвтрэх нэр, нууц үгээ оруулна уу.");
            return;
        }
        setError("");
        setLoading(true);
        const request = new Request('https://wms-cloud.com/api/authenticate', {
        //const request = new Request('http://localhost:8080/authenticate', {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' })
        });
        fetch(request).then((response) => {
            if (response.status == 200) {
                return response.json()
            }
            throw new Error("auth");
        }).then((res) => {
            localStorage.setItem('tok', res.token);
            localStorage.setItem('uname', res.userid);
            localStorage.setItem('role', res.role);
            localStorage.setItem('localbarcode',"");
            localStorage.setItem('localemp_id',"");
            localStorage.setItem('localzahdugaar',"");
            localStorage.setItem('localstat',"");
            localStorage.setItem('localCustidSelect',"Customer");
            setToken(res.token);
        }).catch(() => {
            setError("Нэвтрэх нэр эсвэл нууц үг буруу байна.");
            setLoading(false);
        });
    }

    return <div className="logincont">
        <form className="contbor" onSubmit={handleSubmit} noValidate>
            <div className="loginlogo"><WarehouseOutlinedIcon /></div>
            <div className="conthead">WMS</div>
            <div className="contsub">Агуулахын удирдлагын систем</div>

            {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : <></>}

            <TextField
                inputRef={unameref}
                label="Нэвтрэх нэр"
                autoComplete="username"
                autoFocus
                fullWidth
                margin="dense"
                onKeyDown={keyDownCustUname}
            />
            <TextField
                inputRef={pwdref}
                label="Нууц үг"
                autoComplete="current-password"
                type={pwdSee ? "password" : "text"}
                fullWidth
                margin="dense"
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label={pwdSee ? "Нууц үг харуулах" : "Нууц үг нуух"}
                                onClick={() => setpwdSee(!pwdSee)}
                                edge="end"
                            >
                                {pwdSee ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
            <Button
                type="submit"
                variant="contained"
                size="large"
                fullWidth
                disabled={loading}
                sx={{ mt: 3, height: 48 }}
            >
                {loading ? <CircularProgress size={22} color="inherit" /> : "Нэвтрэх"}
            </Button>
        </form>
        <div className="ctag">© WMSSystems</div>
    </div>
}

export default Login;
